import * as Yup from 'yup'

import { useEffect, useState } from "react"

import { ILookupProps } from './ILookupProps'

export const useLookupValidationSchema = (props: ILookupProps) => {
    const [schema, setSchema] = useState<Yup.StringSchema>();

    useEffect(() => {
        const { label, placeholder, required } = props

        let schema = Yup.string()
        if (required)
            schema = schema.required();

        if (label)
            schema = schema.label(label);
        else if (placeholder)
            schema = schema.label(placeholder);

        setSchema(schema)
        // eslint-disable-next-line
    }, [props])

    return schema
}
